import { inject, Injectable } from '@angular/core';

import { ConverterService, PRODUCT_NORMALIZER } from '@spartacus/core';

import { DpProduct } from '@app/core/types/view/dp-product.interface';
import { DpRelatedParts } from '@app/core/types/view/dp-products-details.interface';

@Injectable({ providedIn: 'root' })
export class DpRelatedPartProductNormalizer {
  readonly #converterService = inject(ConverterService);

  convert(relatedParts: DpRelatedParts[] = []): DpProduct[] {
    return relatedParts.flatMap((part) =>
      part.categories.flatMap((category) =>
        category.products.map((product) =>
          this.#converterService.convert<unknown, DpProduct>(
            {
              ...product,
              category: category.code
            },
            PRODUCT_NORMALIZER
          )
        )
      )
    );
  }
}
